module.exports = __webpack_public_path__ + "static/assets/4a15eab430d071678076a6ad7de14f2c.png";